export default __webpack_public_path__ + "static/media/TG-Logo.e72ad97d.svg";